<template>
  <div>
  <nav>
    <div class="container-fluid">
      <div class="navbar">
        <div class="nav-links">
          <div @click="toggleMenu = !toggleMenu" id="menuBtn" class="menu-btn">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
            <div class="menu-text">Menu</div>
          </div>
          
          <div class="nav-links-res" v-if="toggleMenu">
            <router-link v-if="(header[0]) ? header[0].status : false" 
                        to="/accreditations" class="nav-link">Accreditation</router-link>

            <router-link v-if="(header[1]) ? header[1].status : false" 
                        to="/programs" class="nav-link">Programs</router-link>

            <router-link v-if="(header[8]) ? header[8].status : false"
                        to="/our-certificates" class="nav-link">Certification</router-link>

            <router-link v-if="(header[2]) ? header[2].status : false" 
                        to="/memberships" class="nav-link">Membership</router-link>

            <router-link v-if="(header[3]) ? header[3].status : false" 
                        to="/about" class="nav-link">About</router-link>

            <router-link v-if="(header[4]) ? header[4].status : false" 
                        to="/contact" class="nav-link">Contact Us</router-link>
            <a href="javascript:;" 
              @click="opnPopular(nav.slug)" class="nav-link hidden-links" v-for="(nav, index) in popularSearch" :key="index">
              {{ nav.title }}
            </a>

              <router-link v-for="(pg, idy) in pages" :key="'p'+idy"
                        :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                    class="nav-link"
                    :class="(pg.has_header) ? '' : 'hidden' ">
                    {{ pg.title }}
              </router-link>
          </div>

          <router-link v-if="(header[0]) ? header[0].status : false" 
            to="/accreditations" class="nav-link nav-link-dt">Accreditation</router-link>
          <router-link v-if="(header[1]) ? header[1].status : false" 
            to="/programs" class="nav-link nav-link-dt">Programs</router-link>
          <router-link v-if="(header[8]) ? header[8].status : false"
            to="/our-certificates" class="nav-link nav-link-dt">Certification</router-link>
        </div>

        <router-link to="/" class="nav-logo">
          <img :src="logo.logo" class="img-fluid" alt="" />
          <div v-if="logo.title" class="nav-title" v-html="logo.title"></div>
          <div v-else class="nav-title">GCLA</div>
        </router-link>

        <div class="nav-links">
          <router-link v-if="(header[2]) ? header[2].status : false" 
              to="/memberships" class="nav-link nav-link-dt">Membership</router-link>
          <router-link v-if="(header[3]) ? header[3].status : false" 
            to="/about" class="nav-link nav-link-dt">About</router-link>
          <router-link v-if="(header[4]) ? header[4].status : false" 
            to="/contact" class="nav-link nav-link-dt">Contact Us</router-link>

          <div class="nav-tools">
            <button v-if="authenticated"
                type="button"
                name="button"
                class="navbar-action"
                data-toggle="dropdown">
              <div class="showDropdown">
                  <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                      alt="" 
                      class="img-fluid" 
                      style="width:38px;height:38px;border-radius: 50%;">
                  <div class="dropdown-menu">
                    <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                    <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                  </div>
              </div>
            </button>
            
            <router-link to="/login" v-if="!authenticated" class="nav-su">
              <span>Log In</span>
            </router-link>
            <span class="ml-2 mr-2 vertical-line">|</span>
            <button @click="toggleSearch = !toggleSearch" class="nav-su">
              <span v-if="!toggleSearch" class="icon-search icon"></span>
              <span v-else class="icon-cancel icon"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <SearchPopup v-if="toggleSearch" />
  </div>
</template>


<style scoped="">
.hidden { display: none !important }
.dropdown-menu {
  left: auto;
  right: 0;
}

nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  padding: 13px 0;
  background: #00166F;
  display: flex;
  align-items: center;
  /* box-shadow: 0px 2px 2px #00000017; */
}
.navbar {
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: space-between;
}
.nav-title {
  display: none;
}
.nav-links {
  display: flex;
}
.nav-link {
  color: #ffffff;
  font-size: 20px
}
.nav-link:hover {
  color: #cecece
}
.nav-tools {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
.nav-tools .icon:before,
.nav-tools span {
  color: #fff;
  font-size: 20px;
}
.nav-logo {
  position: absolute;
  top: -8px;
  width: 100px;
  left: calc(50% - 2px);
  transform: translateX(-50%);
  z-index: 30;
}
.vertical-line {
  color: #fff;
  font-size: 18px;
}
.nav-su {
  display: flex;
}
.nav-links-res {
  display: block;
  position: fixed;
  top: 68px;
  left: 0;
  width: 100%;
  height: calc(100% - 68px);
  z-index: 19;
  padding: 0 15px;
  border-top: 1px solid #afafaf;
  background: #00166F;
}
.nav-links-res .nav-link {
  padding-left: 0;
  padding-right: 0;
  font-size: 32px;
  border-bottom: 1px solid #afafaf;
}
.nav-su .icon {
  padding: 3px 3px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {

}

@media (max-width: 767.98px) {
  
}

@media (max-width: 991.98px) {
  nav {
    padding: 12px 0;
  }
  .navbar {
    height: 44px;
  }
  .nav-link-dt {
    display: none;
  }
  .nav-logo {
    width: 88px;
  }
  .nav-links-res {
    display: block;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
import axios from "axios";
import SearchPopup from './SearchPopup';

export default {
  name: "Navbar",
  props: ['close'],
  components: {
    SearchPopup
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      searchPage: false,
      avatar: '',
      authenticated: false,
      toggleSearch: false,
      popularSearch: [],
      toggleMenu: false
    };
  },
  created() {

    axios
        .get(window.baseURL + "/popularSearch")
        .then((res) => {
          const data = res;
          this.popularSearch = res.data.rows;
          console.log(data.data);
        })
        .catch(() => { });

    if (this.$route.path == '/search') {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }
    
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },

    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = res.data;
          this.logo = res.data.logo;
          this.socials = res.data.social;
          this.header = res.data.header;
          console.log(data);
        })
        .catch(() => {});
    },


    //Get Navbar Links in Big Sizes
    fetchPages(){
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
    },

    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

    openMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.add('active');
        el2.classList.add('active');
    },

    closeMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.remove('active');
        el2.classList.remove('active');
    }

  },
  mounted() {
    $("#menuBtn").on('click', function () {
        $('.nav-links').toggleClass('active');
        $(this).toggleClass('active');
    });

  }
};
</script>
